import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-right_jiantou",
  "use": "icon-right_jiantou-usage",
  "viewBox": "0 0 22 22",
  "content": "<symbol viewBox=\"0 0 22 22\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-right_jiantou\"><path d=\"M12.0416 11L7.6416 6.60003L8.89849 5.34314L14.5554 11L8.89849 16.6569L7.6416 15.4L12.0416 11Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol